import { SET_GIFT_VOUCHER_TO_REMOVE } from 'redux/modules/order/actions/types';

const setGiftVoucherToRemove = giftVoucher => dispatch =>
  dispatch({
    type: SET_GIFT_VOUCHER_TO_REMOVE,
    giftVoucher,
  });
export default setGiftVoucherToRemove;
